var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1756 7.08375C10.9226 7.08375 10.7176 7.28878 10.7176 7.54177V11.0838H0.916031V1.28224H4.45802C4.71101 1.28224 4.91604 1.07721 4.91604 0.824227C4.91604 0.571242 4.71101 0.366211 4.45802 0.366211H0.458016C0.205031 0.366211 0 0.571242 0 0.824227V11.5418C0 11.7948 0.205055 11.9998 0.458016 11.9998H11.1756C11.4285 11.9998 11.6336 11.7948 11.6336 11.5418V7.54177C11.6336 7.28881 11.4285 7.08375 11.1756 7.08375Z",
    fill: "#5B6880"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8654 1.7678L10.232 0.134203C10.1462 0.0482344 10.0297 0 9.90816 0C9.78664 0 9.67029 0.0482344 9.58435 0.134203L4.17975 5.53877C4.12418 5.5942 4.08404 5.6629 4.06266 5.73832L3.42143 8.01314C3.37655 8.17268 3.42129 8.34398 3.53853 8.46124C3.62555 8.54827 3.7425 8.59545 3.86234 8.59545C3.90371 8.59545 3.94554 8.5898 3.98646 8.57834L6.26128 7.93711C6.33685 7.91573 6.40557 7.87542 6.46097 7.82002L11.8654 2.41545C12.0443 2.23664 12.0443 1.94655 11.8654 1.7678ZM5.89791 7.08778L4.52494 7.47464L4.91196 6.10198L9.90816 1.1058L10.894 2.09161L5.89791 7.08778Z",
    fill: "#5B6880"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84304 5.5222L4.19531 6.16992L5.82864 7.80325L6.47637 7.15553L4.84304 5.5222Z",
    fill: "#5B6880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d7691c2d2b105b08fa6bf991c7cbf8e8.svg";
export { ForwardRef as ReactComponent };